export default function HTMLBlock({ settings }) {
  const { padding, margin } = settings

  const bgImageStyle = settings.backgroundImage ? {
    backgroundImage: `url('${settings.backgroundImage}')`,
    backgroundSize: settings.backgroundSize || 'cover',
    backgroundPosition: settings.backgroundPosition || 'center center',
    backgroundRepeat: settings.backgroundRepeat || 'no-repeat'
  } : {}

  const borderStyle = settings.borderWidth && settings.borderWidth !== '0px' ? {
    border: `${settings.borderWidth} solid ${settings.borderColor || '#ccc'}`,
    borderRadius: settings.borderRadius || '0px'
  } : {}

  const containerStyle = {
    padding: `${padding?.top || '0px'} ${padding?.right || '0px'} ${padding?.bottom || '0px'} ${padding?.left || '0px'}`,
    margin: `${margin?.top || '0px'} ${margin?.right || '0px'} ${margin?.bottom || '0px'} ${margin?.left || '0px'}`,
    backgroundColor: settings.backgroundColor || 'transparent',
    ...bgImageStyle,
    ...borderStyle,
    width: '100%',
    overflow: 'hidden',
    position: settings.overlayColor ? 'relative' : undefined
  }

  const contentWrapperStyle = {
    width: '100%',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    position: 'relative',
    zIndex: 1
  }

  return (
    <div style={containerStyle}>
      {settings.overlayColor && (
        <div style={{
          position: 'absolute',
          inset: 0,
          backgroundColor: settings.overlayColor,
          zIndex: 0
        }} />
      )}
      <div
        style={contentWrapperStyle}
        dangerouslySetInnerHTML={{ __html: settings.htmlContent || '<p style="color: #999; text-align: center; padding: 20px;">No HTML content</p>' }}
      />
    </div>
  )
}
